
export class AccountAdd {
    name: string;
    email: string;
    firstName: string;
    lastName: string;
    password: string;
}



// WEBPACK FOOTER //
// ./src/app/models/account-add.ts